import { fromJS } from 'immutable'
import * as apiLookUpValuesActions from 'actions/apiLookUpValues'
import { createReducer } from './utils'

export const initialState = fromJS({
  parameterGroupsFetching: false,
  parameterGroups: [],
  parameterAddressesFetching: false,
  parameterAddresses: [],
  compatibilityModulesFetching: false,
  compatibilityModules: [],
  logicalSlots: {},
})

const handlers = {
  [apiLookUpValuesActions.PARAMETER_GROUPS_RECEIVED]: parameterGroupsReceived,
  [apiLookUpValuesActions.PARAMETER_ADDRESSES_RECEIVED]: parameterAddressesReceived,
  [apiLookUpValuesActions.COMPATIBILITY_RULES_RECEIVED]: compatibilityModulesReceived,
  [apiLookUpValuesActions.GET_LOGICAL_SLOTS]: getLogicalSlots,
}

export default createReducer(initialState, handlers)

function getLogicalSlots(state, { data }) {
  const {
    entities: { slots },
  } = data
  return state.mergeDeep({
    logicalSlots: fromJS(slots),
  })
}

function parameterGroupsReceived(state, { data }) {
  return state.merge({
    parameterGroupsFetching: false,
    parameterGroups: data.map((row) => ({
      ...row,
      selected: false,
    })),
  })
}

function parameterAddressesReceived(state, { data }) {
  return state.merge({
    parameterAddressesFetching: false,
    parameterAddresses: data.map((row) => ({
      ...row,
      selected: false,
    })),
  })
}

function compatibilityModulesReceived(state, { data }) {
  const {
    entities: { compatibilityModules },
  } = data
  return state.merge({
    compatibilityModules: fromJS(compatibilityModules),
  })
}
